import React from 'react'
import { Button } from 'reactstrap'
import "./invalidWorkspace.css"



export default function InvalidWorkspaceMessages(props) {
  return (
    <div class="invalid_message_div">
        <div class="invalid_message_card">
            <img class="invalid_message_card_img"
                src="https://img.freepik.com/free-vector/computer-trouble-shooting-concept-illustration_114360-7376.jpg" />

            <h4 class="invalid_message_card_text">
                This  workspace is not added to allowed workspaces to add Dani integration to channel by your
                organization's admin. <br /> Please inform your organization admin to allow this  workspace by providing
                workspace url.
            </h4>

            <div  className="mt-4 text-center">
               <Button color="primary" onClick={()=>{ props.history.push("/home/stories") }}> Go Home  </Button>
            </div>
        </div>
    </div>
  )
}
